import { ReduxState, ReferralInfo as IReferralInfo } from 'interfaces';
import { FC, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { ReferralBanner } from './referralBanner/referralBanner.index';
import { getReferralInfo } from './referral.service';
import { ReferralInfo } from './referralInfo/referralInfo.index';
import { ReferralInvitation } from './referralInvitation/referralInvitation.index';
import { ReferralActions } from './referralActions/referralActions';
import { ReferralInvitedUsers } from './referralInvitedUsers/referralInvitedUsers.index';

interface OwnProps {
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const Referral: FC<Props> = (props) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [info, setInfo] = useState<IReferralInfo>();

    useEffect(() => {
        getReferralInfo(setLoading, setInfo);
    }, []);

    return (
        <div className={'flex flex-col p-6'}>
            <ReferralBanner />
            <ReferralInfo {...{ loading, info }} onWithdrawalComplete={() => getReferralInfo(setLoading, setInfo)} />
            <div className={'flex gap-6 mt-6 items-start max-lg:flex-col'}>
                <ReferralInvitation {...{ loading, info }} />
                <ReferralActions />
            </div>
            <ReferralInvitedUsers />
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Referral);
